const getPrice = (price, currency) => {
  const currentPrice = String(price || 0);
  return {
    price: currentPrice.replace(currency.symbol, ''),
    symbol: currency.symbol,
    onLeft: currency.symbolOnLeft,
  };
};
export default getPrice;
